import { defineMessages } from "react-intl";

const messages = defineMessages({
  cancel: {
    id: "reportPopover.cancel",
    defaultMessage: "Cancel",
    description: "Cancel report button",
  },
  describeIssue: {
    id: "reportPopover.describeIssue",
    defaultMessage: "Describe the issue",
    description: "Report textarea label and placeholder",
  },
  report: {
    id: "reportPopover.submit",
    defaultMessage: "Report",
    description: "Submit report button",
  },
});

export default messages;
